export { Posts as PostPlaceholderFeed } from './Posts';
